/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "n2bv2",
            "endpoint": "https://5xn67i83za.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:f7e7f5c9-7c03-420b-bed2-83ac5ca91cfa",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_GybzITVlL",
    "aws_user_pools_web_client_id": "208q5hfpk3p0tp0bmicambd0vo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


// export default awsmobile;




/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
 
// const awsmobile = {
//     "aws_project_region": "eu-west-3",
//     "aws_cognito_identity_pool_id": "eu-west-3:2711aa6f-d8b4-42de-b170-1ff4786dc3d9",
//     "aws_cognito_region": "eu-west-3",
//     "aws_user_pools_id": "eu-west-3_YIkTepdFY",
//     "aws_user_pools_web_client_id": "14e56u6k1j9gudvi6rddvkd172",
//     "oauth": {},
//     "aws_cognito_username_attributes": [
//         "EMAIL"
//     ],
//     "aws_cognito_social_providers": [],
//     "aws_cognito_signup_attributes": [
//         "EMAIL"
//     ],
//     "aws_cognito_mfa_configuration": "OFF",
//     "aws_cognito_mfa_types": [
//         "SMS"
//     ],
//     "aws_cognito_password_protection_settings": {
//         "passwordPolicyMinLength": 8,
//         "passwordPolicyCharacters": []
//     },
//     "aws_cognito_verification_mechanisms": [
//         "EMAIL"
//     ]
//   };
   
   
  export default awsmobile;
